import { render, staticRenderFns } from "./PepitorAdmin.vue?vue&type=template&id=1cde9da0&"
import script from "./PepitorAdmin.vue?vue&type=script&lang=js&"
export * from "./PepitorAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PepitorAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports